import getLangLocale from 'I18n/utils/getLangLocale';
import { getDefaultLanguage } from 'usage-tracker-core/client/langHelper';
import usageTracker from 'unsubscribe-ui/utils/usageTracker';
import { trackUsage } from 'unsubscribe-ui/utils/tracking/trackingEvents';
import { ACTIONS, SCREENS } from 'unsubscribe-ui/utils/tracking/trackingUtils';
import { UNSUBSCRIBE_MODE } from 'unsubscribe-ui/utils/constants';
export const trackUpdatePreferences = () => {
  usageTracker.track('updatePreferences', {
    action: 'Update Preferences'
  });
};
export const trackUnsubscribeAllPreferences = () => {
  usageTracker.track('unsubscribeAllPreferences', {
    action: 'Unsubscribe All Preferences'
  });
};
export const trackLanguageChange = selectedLangCode => {
  const currentLanguage = getLangLocale();
  const browserLanguage = getDefaultLanguage();
  const selectedLanguage = selectedLangCode;
  usageTracker.track('changePreferedLanguage', {
    action: 'Change Preferred Language',
    'from-language': currentLanguage,
    'to-language': selectedLanguage,
    'device-language-code': browserLanguage
  });
};
export const trackBackUpRedirect = reason => {
  usageTracker.track('redirectToBackup', {
    action: 'Redirect to Backup Page',
    reason
  });
};
export const trackVerifyContact = (success, error) => {
  usageTracker.track('verifyContact', {
    action: 'Verify Contact',
    success,
    'error-type': error
  });
};
export const trackUnsubscribe = mode => {
  const isUnsubscribeAll = mode === UNSUBSCRIBE_MODE.ALL;
  trackUsage({
    screen: isUnsubscribeAll ? SCREENS.UNSUBSCRIBE_ALL_PAGE : SCREENS.UNSUBSCRIBE_SINGLE_PAGE,
    action: isUnsubscribeAll ? ACTIONS.UNSUBSCRIBE_ALL : ACTIONS.UNSUBSCRIBE_SINGLE
  });
};